
import React, { createContext, useContext, useState } from 'react';

interface EnhancedThemeContextType {
  glassMorphism: boolean;
  animations: boolean;
  particles: boolean;
  glowEffects: boolean;
  animationIntensity: 'minimal' | 'moderate' | 'rich';
  reducedMotion: boolean;
  setGlassMorphism: (enabled: boolean) => void;
  setAnimations: (enabled: boolean) => void;
  setParticles: (enabled: boolean) => void;
  setGlowEffects: (enabled: boolean) => void;
  updateUserBehavior: (behavior: Record<string, any>) => void;
}

const EnhancedThemeContext = createContext<EnhancedThemeContextType | null>(null);

export const EnhancedThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [glassMorphism, setGlassMorphism] = useState(true);
  const [animations, setAnimations] = useState(true);
  const [particles, setParticles] = useState(true);
  const [glowEffects, setGlowEffects] = useState(true);
  const [animationIntensity] = useState<'minimal' | 'moderate' | 'rich'>('moderate');
  const [reducedMotion] = useState(false);

  const updateUserBehavior = (behavior: Record<string, any>) => {
    // Implementation for user behavior tracking
    console.log('User behavior updated:', behavior);
  };

  return (
    <EnhancedThemeContext.Provider
      value={{
        glassMorphism,
        animations,
        particles,
        glowEffects,
        animationIntensity,
        reducedMotion,
        setGlassMorphism,
        setAnimations,
        setParticles,
        setGlowEffects,
        updateUserBehavior,
      }}
    >
      {children}
    </EnhancedThemeContext.Provider>
  );
};

export const useEnhancedThemeContext = () => {
  const context = useContext(EnhancedThemeContext);
  if (!context) {
    throw new Error('useEnhancedThemeContext must be used within EnhancedThemeProvider');
  }
  return context;
};

// Export as useEnhancedTheme for backward compatibility
export const useEnhancedTheme = useEnhancedThemeContext;
